<template>
  <div style="padding: 15px">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col cols="3">
        <b-row>
          <b-button size="sm" class="ml-3 mr-2" type="button" @click="mostrarPantallaCompleta" variant="info">Pantalla completa</b-button>
          <b-button v-if="editable"
            size="sm" 
            type="button"
            :disabled="banderaGuardar"
            variant="outline-success"
            @click="obtenerJsonParaEditar"
            ><span v-if="!banderaGuardar">Guardar cambios</span>
            <span v-else>
              <b-spinner small></b-spinner>
              Guardando...
            </span>
          </b-button>
        </b-row>
      </b-col>
      <b-col cols="2">
        <div class="text-center"><span>AVPTx: <strong>{{ avanceGeneral | numeroRedondeoArriba }}%</strong></span></div>
      </b-col>
      <b-col cols="5" class="zoom">

          <form class="gantt_control">
            <input type="radio" id="scale1" class="gantt_radio" name="scale" value="day">
            <label for="scale1" class="ml-2 mr-2">Dias</label>

            <input type="radio" id="scale2" class="gantt_radio" name="scale" value="week">
            <label for="scale2" class="ml-2 mr-2">Semanas</label>

            <input type="radio" id="scale3" class="gantt_radio" name="scale" value="month">
            <label for="scale3" class="ml-2 mr-2">Meses</label>

            <input type="radio" id="scale4" class="gantt_radio" name="scale" value="quarter">
            <label for="scale4" class="ml-2 mr-2">Trimestre</label>
          </form>

      </b-col>
      <b-col cols="2">
          <div class="caja-estatus">
            <div class="estatus"></div>
            <small>Pagado</small>
            <div class="estatus2"></div>
            <small>No pagado</small>
          </div>
      </b-col>
    </b-row>
    <div ref="gantt" class="gantt"></div>
  </div>
</template>

<script>
import { Gantt } from "dhtmlx-gantt";

export default {
  props: {
    editable: Boolean,
    avanceGeneral: {
      type: Number,
      required: true,
      default: 0
    },
    tasks: {
      type: Object,
      default() {
        return { data: [], links: [], collections: {sections: []}, };
      },
    },
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    ganttInst: undefined,
    banderaGuardar: false
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted: function () {
    this.ganttInst = Gantt.getGanttInstance()
    var gantInstLocal = this.ganttInst;

    gantInstLocal.config.drag_resize = false;
    gantInstLocal.config.drag_links = false;

    gantInstLocal.config.date_grid = "%d/%m/%Y";
    gantInstLocal.config.drag_progress = false;
    gantInstLocal.config.order_branch = "marker";
    gantInstLocal.config.scroll_size = 30;
    gantInstLocal.config.horizontal_scroll_key = "altKey";

    //se tiene que activar el readonly para que funcione lo de habilitar/inhabilitar tareas
    gantInstLocal.config.readonly = true;
    gantInstLocal.config.editable_property = "editable";
    gantInstLocal.config.readonly_property = "editable";

    gantInstLocal.attachEvent("onLoadEnd",  this.configurarColores());
    gantInstLocal.templates.task_class = function (start, end, task) {
      var css = [];

      if(task.id){
        css.push("gantt_resource_" + task.id);
      }

      return css.join(" ");
    };

    gantInstLocal.config.columns = [
      // { name: "$index", label: "idx", width: 100 },
      // { name: "id", label: "id", width: 100 },
      { name: "diente", label: "OD", width: 30 },
      { name: "text", label: "Tratamiento", tree: true, width: 300, resize:true },
      { name: "pagado", label: "Estatus", width: 55 },
      { name: "duration", label: "D&iacute;as del tx", width: 80 },
      { name: "tiempoEspera", label: "Tiempo entre tx", width: 100 },
      { name: "start_date", label: "Fecha inicio programada", align: "center", width: 160 },
      { name: "fechaFin", label: "Fecha fin programada", align: "center", width: 140 },
      { name: "fechaRealizacionTratamiento", label: "Fecha realizaci&oacute;n", width: 100 },
      { name: "num", label: "Num", width: 30 },
      { name: "orc", label: "Orden Cl&iacute;nico", align: "left", width: 130, resize:true },
      { name: "fase", label: "Fase", width: 30 },
      { name: "etapa", label: "Etapa", width: 40 },
    ];

    gantInstLocal.config.lightbox.sections=[
      {name:"time", height:72, map_to:"auto", type:"duration"}
    ];

     //? Funcion mover y soltar
    gantInstLocal.attachEvent("onBeforeTaskMove", (id, parent) => {
      var task = gantInstLocal.getTask(id);
      if (task.parent != parent) return false;
      return true;
    });

    gantInstLocal.attachEvent("onRowDragEnd", (id, target) => {
      this.$emit("recorrerFechas1", id, target, gantInstLocal);
    });

    gantInstLocal.attachEvent("onTaskDrag", (id, mode, task) => {
      task.fechaFin = task.end_date;

      return true;
    });

    //?Scrool horizontal

    gantInstLocal.config.layout = {
      css: "gantt_container",
      cols: [
        {
          width: 1000,
          minWidth: 100,
          maxWidth: 1300,
          rows: [
            {
              view: "grid",
              scrollX: "gridScroll",
              scrollable: true,
              scrollY: "scrollVer",
            },

            { view: "scrollbar", id: "gridScroll", group: "horizontal" },
          ],
        },
        { resizer: true, width: 2 },
        {
          rows: [
            { view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer" },
            { view: "scrollbar", id: "scrollHor", group: "horizontal" },
          ],
        },
        { view: "scrollbar", id: "scrollVer" },
      ],
    };
    //* Fin scroll horizonatal //

    //? Zoom dias, semanas, meses, tremestre
    var zoomConfig = {
      levels: [
        {
          name:"day",
          scale_height: 27,
          min_column_width:80,
          scales:[
            {unit: "day", step: 1, format: "%d %M"}
          ]
        },
        {
          name:"week",
          scale_height: 50,
          min_column_width:50,
          scales:[
            {unit: "week", step: 1, format: function (date) {
              var dateToStr = gantInstLocal.date.date_to_str("%d %M");
              var endDate = gantInstLocal.date.add(date, -6, "day");
              var weekNum = gantInstLocal.date.date_to_str("%W")(date);
              return "#" + weekNum + ", " + dateToStr(date) + " - " + dateToStr(endDate);
            }},
            {unit: "day", step: 1, format: "%j %D"}
          ]
        },
        {
          name:"month",
          scale_height: 50,
          min_column_width:120,
          scales:[
            {unit: "month", step: 1, format: "%F, %Y"},
            {unit: "week", step: 1, format: function (date) {
              var dateToStr = gantInstLocal.date.date_to_str("%d %M");
              var endDate = gantInstLocal.date.add(gantInstLocal.date.add(date, 1, "week"), -1, "day");
              return dateToStr(date) + " - " + dateToStr(endDate);
            }}
          ]
        },
        {
          name:"quarter",
          height: 50,
          min_column_width:90,
          scales:[
            {unit: "month", step: 1, format: "%M"},
            {
              unit: "quarter", step: 1, format: function (date) {
                var dateToStr = gantInstLocal.date.date_to_str("%M");
                var endDate = gantInstLocal.date.add(gantInstLocal.date.add(date, 3, "month"), -1, "day");
                return dateToStr(date) + " - " + dateToStr(endDate);
              }
            }
          ]
        },
      ]
    };

    gantInstLocal.ext.zoom.init(zoomConfig);
    gantInstLocal.ext.zoom.setLevel("month");
    gantInstLocal.ext.zoom.attachEvent("onAfterZoom", (level, config) => {
      document.querySelector(".gantt_radio[value='" +config.name+ "']").checked = true;
    })
    document.querySelector(".gantt_radio[value='month']").checked = true;

    var radios = document.getElementsByName("scale");
    for (var i = 0; i < radios.length; i++) {
      radios[i].onclick = function (event) {
        gantInstLocal.ext.zoom.setLevel(event.target.value);
      };
    }
    //* Fin Zoom dias, semanas, meses, trimestre //

    gantInstLocal.config.buttons_left = ["gantt_save_btn", "gantt_cancel_btn"];
    gantInstLocal.config.buttons_right = [];

    gantInstLocal.templates.grid_file = () => "";
    gantInstLocal.templates.grid_folder = () => "";

    gantInstLocal.templates.task_text = (start, end, task) =>
      "<span style='text-align:left; color:white;'>" +
      task.progressNormal +
      "% </span>";


    gantInstLocal.templates.grid_folder = function(item) {
      // return "<div class='gantt_tree_icon gantt_folder_" +
      //     (item.$open ? "open" : "closed") + "'></div>";
      return item.$open ? "" : "("+item.sumatoriaDias+" días)&nbsp;";
    };

    gantInstLocal.plugins({
      keyboard_navigation: true,
      fullscreen: true
    });


    gantInstLocal.i18n.setLocale("es");
    gantInstLocal.init(this.$refs.gantt);
    gantInstLocal.parse(this.$props.tasks);
    // this.actualizarDatos();
  },
  methods: {
      actualizarDatos() {
        this.ganttInst.render();
      },

      mostrarPantallaCompleta() {
        this.ganttInst.expand();
      },

      ocultarPantallaCompleta() {
        this.ganttInst.collapse();
      },

      configurarColores() {
        // use an arbitrary id for the style element
        var styleId = "dynamicGanttStyles";

        // in case you'll be reloading options with colors - reuse previously
        // created style element

        var element = document.getElementById(styleId);
        if(!element){
          element = document.createElement("style");
          element.id = styleId;
          document.querySelector("head").appendChild(element);
        }
        var html = [];

        // generate css styles for each option and write css into the style element,
        this.tasks.collections.sections.forEach(function(r){
          if(r.backgroundColor && r.textColor){
            html.push(".gantt_task_line.gantt_resource_" + r.key + "{" +
                "background-color:"+r.backgroundColor+"; " +
                "}");

            html.push(".gantt_task_line.gantt_resource_" + r.key +
                " .gantt_task_content {" + "color:"+r.textColor+";" +
                "}");
          }
        });
        element.innerHTML = html.join("");
      },

      obtenerJsonParaEditar() {
      let json = [];
      let datosEditar = JSON.parse(JSON.stringify(this.$props.tasks.data));
      datosEditar.forEach((f) => {
        let datos = {
          idTxProgramado: f.id,
          orden: f.orden,
          fechaInicio: this.$moment(f.start_date).format("YYYY-MM-DD"),
          fechaFin: this.$moment(f.end_date).format("YYYY-MM-DD"),
        };
        json.push(datos);
      });
      
      if (json.length > 0) {
        this.$swal({
          icon: "warning",
          text: "¿Está seguro de guardar los cambios?",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCancelButton: true,
          showConfirmButton: true,
        }).then((aceptar) => {
          if (aceptar.value) {
            this.banderaGuardar = true;
            this.$http
              .put(this.$api + "avpt/cambiar/orden/tratamientos", json)
              .then((respuesta) => {
                if (respuesta.data.data) {
                  this.$swal.fire({
                    icon: "success",
                    position: "top-end",
                    toast: true,
                    showConfirmButton: false,
                    timer: 3000,
                    text: "Orden guardado",
                  });
                }
              })
              .finally(() => {
                this.banderaGuardar = false;
              });
          }
        });
      }
    }
  }
};
</script>
 
<style scoped>
@import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";
.gantt {
  height: 500px;
  margin-top: 5px;
}
</style>

<style scoped>
.caja-estatus {
  top: 0;
  margin: 0 auto;
  display: flex;
  margin-bottom: 5px;
}

.estatus {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: #5cb85c;
  margin-right: 5px;
}

.estatus2 {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: #ffc300;
  margin-right: 5px;
  margin-left: 6px;
}

.estatus3 {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: #ff0000;
  margin-right: 5px;
  margin-left: 6px;
}
</style>